import { Row } from 'app/design/primitives/box';
import { Modal } from 'app/design/primitives/modal';
import { Text } from 'app/design/primitives/text';
import { useScopedTranslation } from 'app/hooks/i18n';
import { type Dispatch, type SetStateAction } from 'react';
import { Pressable } from 'react-native';
import { IconMinus, IconPlus } from '@tabler/icons-react-native';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
import { Button } from 'app/shopify';
import { theme } from './shared';

export function DuplicateListingsModal({
  count,
  isPending,
  onClose,
  onConfirm,
  open,
  setCount,
}: {
  count: number;
  isPending: boolean;
  onClose: () => void;
  onConfirm: () => void;
  open: boolean;
  setCount: Dispatch<SetStateAction<number>>;
}) {
  const { t } = useScopedTranslation();
  return (
    <Modal onClose={onClose} open={open} transparent>
      <Modal.Card gap="spacing.general.x6">
        <Modal.Title allowClose onClose={onClose}>
          {t('duplicateModal.title')}
        </Modal.Title>
        <Row alignItems="center" justifyContent="space-between" paddingHorizontal="spacing.general.x2">
          <Text fontWeight="700" variant="bodyBase">
            {t('duplicateModal.copies')}
          </Text>
          <Row
            alignItems="center"
            borderColor="border.secondary"
            borderRadius="radius.lg"
            borderWidth={1}
            gap="spacing.general.x4"
            padding="spacing.general.x2"
          >
            <Pressable disabled={count <= 1} onPress={() => setCount((value) => Math.max(1, value - 1))}>
              <IconMinus color={theme.colors['icon.primary']} size={20} strokeWidth={ICON_STROKE_WIDTH} />
            </Pressable>
            <Text variant="bodyBase">{count}</Text>
            <Pressable disabled={count >= 99} onPress={() => setCount((value) => Math.min(99, value + 1))}>
              <IconPlus color={theme.colors['icon.primary']} size={20} strokeWidth={ICON_STROKE_WIDTH} />
            </Pressable>
          </Row>
        </Row>
        <Row gap="spacing.general.x4" justifyContent="flex-end">
          <Button label={t('cancelButton')} onPress={onClose} variant="secondaryNeutral" />
          <Button disabled={isPending} label={t('duplicateModal.confirm')} onPress={onConfirm} variant="primary" />
        </Row>
      </Modal.Card>
    </Modal>
  );
}
